/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GeneralSecretRequest } from '../models/GeneralSecretRequest';
import type { GeneralSecretResult } from '../models/GeneralSecretResult';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SecretControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns GeneralSecretResult OK
     * @throws ApiError
     */
    public getSecretKey({
        requestBody,
    }: {
        requestBody: GeneralSecretRequest,
    }): CancelablePromise<GeneralSecretResult> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/secret/key',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
